export default __webpack_public_path__ + "static/salesPiplineImage-d94e7c13db34a8e27fbaaab6131ba652.webp";